import React from 'react'
import mainContentPrizes from '../assets/img/nagrade-2025.jpg'

const MainContent = () => {

  return (
    <div>
      <article className="mainContent pb-0 bg-white">
        <div className="px-2 lg:px-12">
          <h1 className="font-bold text-2xl sm:text-4xl lg:text-5xl mb-8 lg:mb-10">Dr. Oetker nagrađuje kreativnost!</h1>
          <h2 className="font-bold text-xl sm:text-2xl lg:text-3xl max-w-[60ch] mx-auto mb-8 lg:mb-10">Kupi, učestvuj i osvoji vrijedne nagrade!</h2>
          <p>Učestvuj u velikom nagradnom natječaju i pokaži svoju kreativnost – Dr. Oetker te nagrađuje vrijednim kućanskim aparatima i poklon paketima!</p>
          <br />
          <p>Kupovinom Dr. Oetker sastojaka za kolače u bilo kojoj prodavnici Binga u vrijednosti od najmanje 10 KM, ostvaruješ pravo na učešće. Sačuvaj račun i u aplikaciji unesi svoje podatke, fotografiju računa te odgovori na kreativno pitanje.</p>
          <br />
          <p>Najkreativniji odgovori osvajaju:</p>
          <br />
          <p>🎁 3x Bosch perilice posuđa</p>
          <p>🎁 2x Bosch bežični usisivač</p>
          <p>🎁 50x Dr. Oetker poklon paketa</p>
          <br />
         <p> Natječaj traje od <strong>1.5. do 6.6.2025.</strong>, a učestvovati mogu svi s prebivalištem u BiH.</p>
          <p>Proglašenje dobitnika bit će 12.6.2025. na našoj web stranici.</p>
          <br />
          <p>Sretno i – neka kreativnost pobijedi!</p>
         
          <br />
          <br />
          <div className="flex justify-center flex-column pt-5 py-14 w-full">
            <div className="w-full">
              <h3 className="font-bold text-xl sm:text-2xl lg:text-3xl max-w-[60ch] mx-auto mb-6 lg:mb-6">Dobitnici</h3>
              <p className='font-bold'>BOSCH MAŠINA ZA SUĐE</p>
              <p>Vera Guska, Banja Luka</p>
              <p>Mirjana Franjić, Tuzla</p>
              <p>Enisa Mujkic, Sarajevo</p>
              <br />
              <p className='font-bold'>BOSCH USISAVAČ</p>
              <p>Zeljka Kokotic, Mostar</p>
              <p>Edin Kovac, Zenica</p>
              <br />
              <p className='font-bold'>DR. OETKER POKLON PAKET</p>
              <div className="flex flex-wrap justify-between">
                <div className="flex-1 min-w-full md:min-w-[30%] px-0 md:px-2">
                  <p>Lejla Sadiković, Bugojno</p>
                  <p>Gordana Milošević, Modrica</p>
                  <p>Biljana Pecanac, Gradiška</p>
                  <p>Zinaida Mujkanovic, Tuzla</p>
                  <p>Irma Djulović, Banovići</p>
                  <p>Tanja Radulović, Prijedor</p>
                  <p>Nevena Bogun, Prijedor</p>
                  <p>Miralem Salkić, Zenica</p>
                  <p>Tijana Mirković, Bihać</p>
                  <p>Amra Borovina, Sarajevo</p>
                  <p>Danka Zekić, Zvornik</p>
                  <p>Emina Kuršumlić, Sarajevo</p>
                  <p>Dijana Mitrović, Dobroj</p>
                  <p>Luca Ramljak, Bila</p>
                  <p>Adnana Delić, Maglaj</p>
                  <p>Mirela Sesar, Mostar</p>
                  <p>Alma Deronja, Deronja</p>
                </div>
                <div className="flex-1 min-w-full md:min-w-[30%] px-0 md:px-2">
                  <p>Emra Palić, Turbe</p>
                  <p>Azra Muharemović, Srebrenik</p>
                  <p>Jasmina Hasić, Banovići</p>
                  <p>Maida Muminović, Tuzla</p>
                  <p>Selma Fajković, Bihać</p>
                  <p>Nikola Andrić, Bijeljina</p>
                  <p>Nasiha Demir, Kakanj</p>
                  <p>Biljana Popović, Trebinje</p>
                  <p>Mirsada Fuško, Travnik</p>
                  <p>Naida Ramić, Sarajevo</p>
                  <p>Dado Ljubunčić, Sarajevo</p>
                  <p>Vesna Jevrić, Breza</p>
                  <p>Maja Simić, Prnjavor</p>
                  <p>Mirela Sabić, Kakanj</p>
                  <p>Olgica Davidović, Doboj</p>
                  <p>Nedeljka Mičić, Istočno Sarajevo</p>
                  <p>Vernesa Sipić, Travnik</p>
                </div>
                <div className="flex-1 min-w-full md:min-w-[30%] px-0 md:px-2">
                  <p>Zulija Hamzić, Srebrenik</p>
                      <p>Maja Hajdarević, Tuzla</p>
                      <p>Adisa Kadić, Sarajevo</p>
                      <p>Zehra Muratspahić, Bugojno </p>
                      <p>Marin Susac, Mostar</p>
                      <p>Maida Lokvnčić, Sarajevo, Ilidža</p>
                      <p>Azra Veladžić, Bihać</p>
                      <p>Edina Jusić, Breza</p>
                      <p>Sladjana Lazić, Doboj</p>
                      <p>Azra Dzigal, Sarajevo</p>
                      <p>Munira Custo, Bugojno</p>
                      <p>Branko Erceg, Doboj</p>
                      <p>Deniza Kamenjasević, Gračanica </p>
                      <p>Samira Kanurić, Zenica</p>
                      <p>Danijela Batinić, Bileca</p>
                      <p>Danijela Malinović, Vitez</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
      <div className="flex justify-center">
        <img className="w-full" src={mainContentPrizes} alt="game prizes" />
      </div>
      
    </div>
  )

}

export default MainContent